import styled from 'styled-components'

export const Container = styled.div`
    color: ${(props) => {return props.theme.colorSecoundary}};
    background: ${(props) => {return props.theme.colorPrimary}};
    height: ${(props) => {return props.theme.footerHeight}}px;
    position: relative;
    bottom: 0px;
    display: flex;
    align-items: center;

    p {
        color: ${(props) => {return props.theme.colorSecoundary}};
        font-size: .9rem;
        margin: 0 0 0 50px;
    }
`
